/*
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-02-22 14:29:05
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-02-22 14:33:18
 */
import md5 from 'md5'

import request from '@/utils/request'
import { restData } from '@/config'

// token登录
export function appTokenLogin (params) {
  return request.get(restData.checkUserInfoUrl, params)
  // return request.post(restData.checkUserInfoUrl, params)
}

// session登录
export function appSessionLogin () {
  // return request.post(restData.checkUserInfoUrl)
  return request.get(restData.checkUserInfoUrl)
}

// 用于页面登录
export function pageLogin (params) {
  const { username, password } = params

  return request.post(restData.checkLoginUrl, {
    username,
    password: params.md5 ? password : md5(password),
  })
}

// 用于页面注销
export function pageLogout () {
  return request.get(restData.logoutUrl)
}

// 获取字典数据接口
export function getDictionaryByType ({ type }) {
  return request.post('/api/json/getDict', { dictType: type })
}

// 递归格式化字典数据
// eslint-disable-next-line no-unused-vars
function reduceDic (list) {
  return list.map(({ name, value, parentName, typeId, dictChildList }) => {
    const item = {
      value,
      text: name,
    }

    parentName && Object.assign(item, { parentName })

    typeId && Object.assign(item, { typeId })

    Array.isArray(dictChildList) && Object.assign(item, { children: reduceDic(dictChildList) })

    return item
  })
}

// 服务于修改密码操作
export function changePassword (params) {
  return request.post('/api/json/user/password/update', params)
}

// 获取微信扫码登录图片
export function getWxLogin () {
  return request.get('/api/wx/login')
}
